import $ from "jquery";
import ProductListGallery from 'utils/productlist_gallery';

export default function DisplayModusToggle() {
  function sendRequestWithChoice(hrefUrl) {
    $.ajax({
      cache: false,
      url: hrefUrl
    });
  }

  function triggerChangeEvent() {
    var event = "jungheinrich-product-list-style-changed";
    $(document).trigger(event);
    $('.product-grid-item').removeClass('sales-box-open');
    republish(this);
  }

  function republish() {
    var productListGallery = new ProductListGallery();
    productListGallery.republish();
  }

  function doAfterProductStyleChange($link) {
    sendRequestWithChoice($link.attr('href'));
    triggerChangeEvent();
  }

  function installToggleOnProductlistButtons() {
    $('.list-btn').off("click").on("click", function (event) {
      event.preventDefault();
      $(this).addClass('hidden-important');
      $('.tile-btn').removeClass('hidden-important');
      $('.page-product-list').addClass("product-list-style");
      $('.page-product-list').removeClass("product-grid-style");
      doAfterProductStyleChange($(this));
    });

    $('.tile-btn').off("click").on("click", function (event) {
      event.preventDefault();
      $(this).addClass('hidden-important');
      $('.list-btn').removeClass('hidden-important');
      $('.page-product-list').removeClass("product-list-style");
      $('.page-product-list').addClass('product-grid-style');
      doAfterProductStyleChange($(this));
    });
  }

  installToggleOnProductlistButtons();
  return {};
}
